import React from 'react';
import './styles/homePageGallery.scss';
import { BsAirplane, BsGift } from 'react-icons/bs';
import { TfiCup } from 'react-icons/tfi';
import { GiTakeMyMoney } from 'react-icons/gi';

function HomePageGallery() {
    return (
        <section className='home_page-gallery'>
            <div className='shop-special-wrapepr'>
                <div className='shop-special-item'>
                    <BsAirplane className='icon' />
                    <p className='special-item-name'>FAST DELIVERY</p>
                    <p className='special-item-description'>
                        Some day delivery as soon as possible
                    </p>
                </div>
                <div className='shop-special-item'>
                    <BsGift className='icon' />
                    <p className='special-item-name'>SPECIAL DISCOUNT</p>
                    <p className='special-item-description'>
                        Get attractive offers day by day
                    </p>
                </div>
                <div className='shop-special-item'>
                    <GiTakeMyMoney className='icon' />
                    <p className='special-item-name'>MONEY RETURNS</p>
                    <p className='special-item-description'>
                        100% Money back guarantee
                    </p>
                </div>
                <div className='shop-special-item'>
                    <TfiCup className='icon' />
                    <p className='special-item-name'>HIGH QUALITY</p>
                    <p className='special-item-description'>
                        Some day delivery as soon as possible
                    </p>
                </div>
            </div>

            <p className='home_page-gallery-info'>Share Your Style With</p>

            <div className='home-page-gallery-description'>
                <h2>#HOMESTORE</h2>
                <button>SUBSCRIBE</button>
            </div>

            <div className='gallery-container'>
                <div className='gallery-part'>
                    <div
                        className='gallery-image'
                        style={{
                            backgroundImage: `url('${process.env.PUBLIC_URL}/gallery1.png')`,
                        }}
                    ></div>
                    <div
                        className='gallery-image'
                        style={{
                            backgroundImage: `url('${process.env.PUBLIC_URL}/gallery3.png')`,
                        }}
                    ></div>
                    <div
                        className='gallery-image'
                        style={{
                            backgroundImage: `url('${process.env.PUBLIC_URL}/gallery2.png')`,
                        }}
                    ></div>
                    <div
                        className='gallery-image'
                        style={{
                            backgroundImage: `url('${process.env.PUBLIC_URL}/category2.jpg')`,
                        }}
                    ></div>
                </div>
                <div
                    className='gallery-part'
                    style={{
                        backgroundImage: `url('${process.env.PUBLIC_URL}/gallery5.png')`,
                    }}
                ></div>
                <p className='homeStore'>@HOMESTORE</p>
            </div>
        </section>
    );
}

export default HomePageGallery;
